/** Число для счётчиков интерфейса: до 10 000 — целиком, дальше — 48.6K, 1.2M, 3.4B (одна цифра после точки). */
export function formatCompact(n: number): string {
  const v = Math.max(0, Math.floor(n));
  if (v < 10_000) return String(v);
  const units: [number, string][] = [
    [1e9, "B"],
    [1e6, "M"],
    [1e3, "K"],
  ];
  for (const [base, suffix] of units) {
    if (v >= base) {
      const x = Math.floor((v / base) * 10) / 10;
      return `${x >= 100 ? Math.floor(x) : x}${suffix}`;
    }
  }
  return String(v);
}

/** Доля 0…1 → промилле 0…1000 (целое, с ограничением). */
export function permille(part: number, whole: number): number {
  if (whole <= 0) return 0;
  return Math.max(0, Math.min(1000, Math.round((part * 1000) / whole)));
}
